import React from "react";
import useConsentTexts from "@/hooks/useConsentTexts";

export const CONSENT_LABELS = {
  request: "Rappel téléphonique sur ma demande",
  marketing_phone: "Offres commerciales par téléphone",
  marketing_email: "Offres commerciales par email",
  marketing: "Offres commerciales (téléphone et email)",
};

export default function ConsentCheckboxes({ source, value, onChange, dark = false, testPrefix }) {
  const cfg = useConsentTexts();
  if (!cfg) return <div data-testid={`${testPrefix}-consent-loading`} className="h-32" />;
  const texts = cfg.texts[source];
  const tone = dark ? "text-white/75" : "text-md-muted";
  const link = dark ? "underline hover:text-md-secondary" : "underline hover:text-md-primary";

  return (
    <fieldset className="space-y-3" data-testid={`${testPrefix}-consent-block`}>
      <legend className={`text-[10px] uppercase tracking-widest font-bold mb-2 ${dark ? "text-md-secondary" : "text-md-accent"}`}>
        Vos choix de contact — tous facultatifs
      </legend>
      {cfg.form_keys.map((key) => (
        <label key={key} className={`flex items-start gap-3 text-xs leading-relaxed cursor-pointer ${tone}`}>
          <input
            type="checkbox"
            data-testid={`${testPrefix}-consent-${key}`}
            checked={!!value[key]}
            onChange={(e) => onChange({ ...value, [key]: e.target.checked })}
            className="mt-0.5 w-4 h-4 accent-md-secondary flex-shrink-0"
          />
          <span>
            <strong className={dark ? "text-white/90" : "text-md-primary"}>{CONSENT_LABELS[key]} — </strong>
            {texts[key]}
          </span>
        </label>
      ))}
      <p className={`text-[11px] leading-relaxed ${dark ? "text-white/50" : "text-md-muted/80"}`}>
        Appelant : {cfg.caller}. Appels du lundi au vendredi, 10h–13h et 14h–20h. Ces choix sont indépendants de
        l'acceptation des CGU et des CGV. La preuve de votre consentement est conservée 3 ans après sa fin et vous est
        communiquée gratuitement.{" "}
        <a href="/cgu" target="_blank" rel="noreferrer" className={link}>CGU</a> ·{" "}
        <a href="/confidentialite" target="_blank" rel="noreferrer" className={link}>Confidentialité</a> ·{" "}
        <a href="/consentement" target="_blank" rel="noreferrer" className={link}>Retirer mon consentement</a>
      </p>
    </fieldset>
  );
}
